export const ShieldIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.83497 6.02873H3.13409V5.44112H7.83497V6.02873Z"
        fill="var(--swapper-text-color)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.47982 14.1869C3.93537 13.798 2.66037 12.9118 1.65482 11.5285C0.649262 10.1452 0.146484 8.60907 0.146484 6.92018V2.85352L5.47982 0.853516L10.8132 2.85352V6.92018C10.8132 8.60907 10.3104 10.1452 9.30482 11.5285C8.29926 12.9118 7.02426 13.798 5.47982 14.1869ZM2.71909 5.02613C2.60402 5.1412 2.54648 5.27953 2.54648 5.44112V8.96678C2.54648 9.12837 2.60402 9.26671 2.71909 9.38178C2.83417 9.49685 2.9725 9.55439 3.13409 9.55439H4.33869V8.96678H3.13409V7.20395H8.42258V5.44112C8.42258 5.27953 8.36504 5.1412 8.24997 5.02613C8.13489 4.91105 7.99656 4.85352 7.83497 4.85352H3.13409C2.9725 4.85352 2.83417 4.91105 2.71909 5.02613ZM5.10259 8.89333L6.35126 10.142L8.42258 8.07068L8.01125 7.64466L6.35126 9.30466L5.51391 8.482L5.10259 8.89333Z"
        fill="var(--swapper-text-color)"
      />
    </svg>
  );
};
